function resizeImg (img, option) {
  return `${process.env.VUE_APP_URL_SERVER_IMAGE}/${option}/${img}`
}

export default resizeImg
